// extracted by mini-css-extract-plugin
export default {"button":"DownloadAttList_button__2LGyX"};